import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SITE_URL, useSeo } from "../lib/useSeo";
import { Hero } from "../sections/Hero";
import { TrustBadges } from "../sections/TrustBadges";
import { WhyChooseUs } from "../sections/WhyChooseUs";
import { Services } from "../sections/Services";
import { HowItWorks } from "../sections/HowItWorks";
import { Pricing } from "../sections/Pricing";
import { AreasWeCover } from "../sections/AreasWeCover";
import { MeetInstructor } from "../sections/MeetInstructor";
import { SuccessStories } from "../sections/SuccessStories";
import { Gallery } from "../sections/Gallery";
import { Reviews } from "../sections/Reviews";
import { Faq } from "../sections/Faq";
import { FinalCta } from "../sections/FinalCta";

export default function Home() {
  const location = useLocation();
  useSeo({
    title: "Driving Lessons in Northolt | Manual and Automatic | S-UK",
    description:
      "Manual and automatic driving lessons in Northolt, Greenford, Southall and South Harrow. View 50-minute lesson prices and book with S-UK Driving School.",
    canonical: `${SITE_URL}/`,
    keywords:
      "driving school Northolt, driving lessons Northolt, automatic driving lessons Northolt, manual driving lessons Northolt, driving instructor Northolt, driving school Greenford, driving lessons Greenford, driving school Southall, driving lessons Southall, driving school South Harrow, driving lessons South Harrow",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "Driving Lessons in Northolt | S-UK Driving School",
      url: `${SITE_URL}/`,
      description:
        "We provide manual and automatic driving lessons across Northolt, Greenford, Southall and South Harrow.",
      inLanguage: "en-GB",
      mainEntity: { "@id": `${SITE_URL}/#business` },
    },
  });

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, [location.hash]);

  return (
    <>
      <Hero />
      <TrustBadges />
      <WhyChooseUs />
      <Services />
      <HowItWorks />
      <Pricing />
      <AreasWeCover />
      <MeetInstructor />
      <SuccessStories />
      <Gallery />
      <Reviews />
      <Faq />
      <FinalCta />
    </>
  );
}
